export default "__VITE_ASSET__BVUSLm_y__"